// Не-компонентные хелперы интерактивов вынесены из interactions-admin.tsx,
// чтобы файл компонента экспортировал только компоненты (react-refresh:
// only-export-components).

export type InteractionType = 'POLL' | 'QUESTION_COLLECTION';

export const INTERACTION_TYPE_META: Record<
  InteractionType,
  { label: string; description: string }
> = {
  POLL: {
    label: 'Голосование',
    description: 'Варианты ответа, проценты и быстрый контроль статуса.',
  },
  QUESTION_COLLECTION: {
    label: 'Сбор ответов',
    description:
      'Текстовые ответы участников. Включите отметку ответов, если оператору нужно закрывать вопросы.',
  },
};

export function getInteractionResponseLabel(count: number): string {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return `${count} ответ`;
  }

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return `${count} ответа`;
  }

  return `${count} ответов`;
}
